// extracted by mini-css-extract-plugin
module.exports = {"root":"IconSuccess_root__2ZnkE","fillColor":"IconSuccess_fillColor__2CXJX"};